import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';

import { WafCaptchaInterceptor } from 'Angular/services/core/waf-captcha.interceptor';
import { WAF_CAPTCHA_API_KEY, WafCaptchaService } from 'Angular/services/core/waf-captcha.service';
import { WafTokenInterceptor } from 'Angular/services/core/waf-token.interceptor';
import { SentryErrorHandler } from 'Angular/services/sentry/sentry.service';

// This module sets the CSRF tokens. It must be imported into every app.module.ts!
@NgModule({
    imports: [
        HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'csrftoken',
            headerName: 'X-CSRFToken',
        }),
    ],
    providers: [
        {
            provide: ErrorHandler,
            useClass: SentryErrorHandler,
        },
        WafCaptchaService,
        {
            provide: WAF_CAPTCHA_API_KEY,
            useFactory: () => (window as any).WAF_CAPTCHA_API_KEY ?? null,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: WafCaptchaInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: WafTokenInterceptor,
            multi: true,
        },
    ],
})
export class ConfigModule {}
